module.exports = {
      id: "simple-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite.svg#simple-arrow",
      toString: function () {
        return this.url;
      }
    }